define('areas/tutorialpopup/viewmodels/index',["require", "exports", 'durandal/app', "models/portal"], function (require, exports, app, Portal) {
    "use strict";
    var TotorialModal = (function () {
        function TotorialModal(externalLink) {
            this._shell = Portal.Context.shell;
            this._userManager = this._shell.userManager;
        }
        TotorialModal.prototype.activate = function (data) {
            this.navigationUrl = data.defaultData.dialogPath;
        };
        TotorialModal.prototype.closeTutorialPopUp = function () {
            this.navigationUrl = "";
            // update show-tutorial info in database
            this._userManager.saveSettings("show-tutorial", { 'ShowTutorial': false });
            app.closeDialog(this);
        };
        return TotorialModal;
    }());
    return TotorialModal;
});

